import * as React from 'react';
import translate from '../../locale/translate';

import * as WidgetComponents from '../widget';
import WidgetPrintWrapper from './WidgetPrintWrapper';

import { Widget } from '../../store/models';

interface IProps {
    widgets: Widget[]
}

export default class WidgetPrintCanvas extends React.Component<IProps, void> {
    static propTypes = {
        widgets: React.PropTypes.array.isRequired
    };

    render() {
        const { widgets } = this.props;
        const renderWidget = this.renderWidget.bind(this);

        if (widgets.length) {
            return (
                <div>
                    {widgets.map(this.renderWidget)}
                </div>
            );
        }

        return (
            <div className="jumbotron">
                <h1>{translate.gettext("This is your report.")}</h1>
                <p>{translate.gettext("Choose components from the menu in the editor to create your custom report.")}</p>
            </div>
        );
    }

    renderWidget(widget: Widget) {
        let Ele;

        const WidgetComponent = WidgetComponents.getByName(widget.type);

        if (WidgetComponent) {
            Ele = <WidgetComponent.WidgetContainer widgetId={widget.id} />;
        } else {
            console.warn(`${widget.type} is an unknown widget type`);
        }

        if(!Ele) {
            console.warn(`${widget.type} has no WidgetContainer`);
            return null;
        }

        return (
            <WidgetPrintWrapper key={widget.id}>
                {Ele}
            </WidgetPrintWrapper>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widgetCanvas/WidgetPrintCanvas.tsx